import TextFieldStyled from "@/components/TextFieldStyled";
import { ZipcodeSelector } from "@/components/ZipcodeSelector";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Typography from "@mui/material/Typography";

const NetworkLocationFormBase = ({ formValues, onChange }) => {
  const handleInputChanged = (event, value) => {
    if (onChange && typeof onChange === "function") {
      onChange(event, value);
    }
  };

  return (
    <>
      <Typography
        variant="h4"
        component="p"
        color="common.black"
        sx={{ mt: 4 }}
      >
        Weitere Informationen
      </Typography>
      <TextFieldStyled
        required
        type="text"
        name="name"
        label="Name"
        onChange={handleInputChanged}
        placeholder={
          formValues?.category?.id === "bands"
            ? "Musiker*innen-name"
            : "Name der Location"
        }
      />
      {formValues?.category?.id !== "bands" && (
        <>
          <TextFieldStyled
            required
            type="text"
            name="street"
            label="Straße & Hausnummer"
            onChange={handleInputChanged}
            placeholder="Musterstraße 23"
          />
        </>
      )}
      <ZipcodeSelector
        required
        name="zipcode"
        label="Stadt"
        onChange={handleInputChanged}
      />
      {formValues?.category?.id !== "bands" && (
        <>
          <TextFieldStyled
            required={
              ["2", "3", "4"].findIndex((e) => e === formValues?.category) !==
              -1
            }
            type="phone"
            name="phone"
            label="Telefon"
            onChange={handleInputChanged}
            placeholder="0172 12345678"
          />
          <TextFieldStyled
            required={
              ["2", "3", "4"].findIndex((e) => e === formValues?.category) !==
              -1
            }
            type="email"
            name="email"
            label="E-Mail"
            onChange={handleInputChanged}
            placeholder="mail@example.com"
          />
          <div className="textarea">
            <label>Beschreibung</label>
            <TextareaAutosize
              aria-label="textarea"
              placeholder="Beschreibe hier deine Location"
              name="description"
              minRows={4}
              onChange={handleInputChanged}
              style={{ width: "100%" }}
            />
          </div>
        </>
      )}
    </>
  );
};

export default NetworkLocationFormBase;
